import React from 'react'

const ClaimsSummary = () => {
  return (
    <div>
      
    </div>
  )
}

export default ClaimsSummary
